import React, { type FC } from "react";
import classes from "./Spinner.module.css";

type SpinnerProps = {
  theme?: "light" | "dark";
};

const Spinner: FC<SpinnerProps> = ({ theme }) => {
  return (
    <div
      className={`${classes.spinner} ${theme === "light" && classes.white}`}
    ></div>
  );
};

export default Spinner;
